import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import { Body1, Heading6, Title1 } from '@ui/Typography'
import { Link } from '@ui/components/Link'
import { PageSection } from '@ui/components/PageSection'

import { MarketDataClassificationStatus } from '@model/AccountDetailedDto'

import { useDispatchOpenChat } from '@hooks/useDispatchOpenChat'

import styles from './MarketDataClassification.module.scss'

export const MarketDataClassificationPage: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useAccountReadContext()
  const { dispatchOpenChat } = useDispatchOpenChat()

  const marketDataClassification =
    account?.marketDataClassification?.id === MarketDataClassificationStatus.Professional
      ? t('Profile.Market-Data Professional')
      : t('Profile.Market-Data Private')

  return (
    <Fragment>
      <PageSection title={t('Profile.Market Data Classification')} />
      <div className={styles.marketDataClassificattion}>
        <Heading6 medium>{t('Account Type')}</Heading6>
        <Title1>
          {t('Profile.Current status')}{' '}
          <Title1 className={styles.statusValue} medium>
            {marketDataClassification}
          </Title1>
        </Title1>
        <Body1>
          {t('Profile.If you have any questions regarding your Market Data Classification')}{' '}
          <Link onClick={dispatchOpenChat}>{t('Contact Support')}</Link>.
        </Body1>
      </div>
    </Fragment>
  )
}
